import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { GridContainer } from '@lusha-ui/core';
import { TextField } from '@lusha-ui/input';
import { Radio } from '@lusha-ui/radio';
import { Text } from '@lusha-ui/text';
import _ from 'lodash';
import React, { useCallback } from 'react';
import optionsList from '../options';
const MESSAGE_SIZE_LIMIT = 250;
function RadioGroup(props) {
    const { option, setOption, message, setMessage } = props;
    const handleChange = useCallback((txt) => {
        if (txt.length <= MESSAGE_SIZE_LIMIT) {
            setMessage(txt);
        }
        else {
            const txtLimit = txt.slice(0, MESSAGE_SIZE_LIMIT);
            setMessage(txtLimit);
        }
    }, []);
    return (_jsxs("div", { css: css `
        display: flex;
        flex-direction: column;
        gap: 12px;
      `, children: [_jsx(Text, { variant: 'body-2-r', children: "Tell us why you wish to unsubscribe (optional):" }), _.map(optionsList, (item) => (_jsxs("div", { children: [_jsx(Radio, { value: item.value, onChange: setOption, label: item.label, checked: item.value === option }), item.value === 'other' && option === 'other' && (_jsxs("div", { css: css `
                margin-top: 8px;
                margin-left: 24px;
              `, children: [_jsx(TextField, { name: 'message', value: message, onChangeText: handleChange, placeholder: 'Type here', multiline: true, css: css `
                  height: 62px;
                ` }), _jsx(GridContainer, { justifyContent: 'flex-end', children: _jsxs(Text, { variant: 'body-3-r', children: [message.length, "/", MESSAGE_SIZE_LIMIT] }) })] }))] }, `radio-group/${item.value}`)))] }));
}
export default RadioGroup;
